//THIS MUST BE A GLOBAL TO ALLOW THE RECAPTCHA SCRIPT FROM GOOGLE TO ACCESS IT
function recaptchaResponse(token) {
    $("#recaptchaToken").val(token);
    $("#newsletterSignupRecaptchaModal").modal("hide");
    submitNewsletterSignup();
}

function submitNewsletterSignup() {
    $("#newsletterSignupContainer .processing-signup").removeClass("hidden");
    $("#newsletterSignupForm").addClass("hidden");

    $.ajax({
        type: 'POST',
        url: 'https://api.meyernaturalfoods.com/api/v1/newsletter/submit',
        datatype: "json",
        data: JSON.stringify({
            email: $("#newsletterSignup_Email").val(),
            firstName: $("#newsletterSignup_FirstName").val(),
            lastName: $("#newsletterSignup_LastName").val(),
            postalCode: $("#newsletterSignup_ZipCode").val(),
            recaptchaToken: $("#recaptchaToken").val()
        }),
        contentType: "application/json; charset=utf-8"
    }).done(function (data) {
      if (typeof data.success !== "undefined" && data.success === true) {
        $("#newsletterSignupMessage").text("Thank you for signing up for the Meyer Market newsletter.  You should receive an email with information on how to confirm your email.")
          .removeClass("hidden")
          .addClass("success");
        $(".instructions").addClass("hidden");
        $("#newsletterSignupForm").addClass("hidden");
      }
      else {
        Utility.displayMessage("error", "#newsletterSignupMessage", Object.entries(data.errors).map((item) => item[1]).join("<br>"));
        $("#newsletterSignupForm").removeClass("hidden");
      }
    }).fail(function (data) {
      if (typeof data.responseJSON.errors !== "undefined"){
        Utility.displayMessage("error", "#newsletterSignupMessage", Object.entries(data.responseJSON.errors).map((item) => item[1]).join("<br>"));
      }
      else{
        Utility.displayMessage("error", "#newsletterSignupMessage", "Sorry for the inconvenience, but an error has occurred.  Please reload the page and try again.");  
      }
      $("#newsletterSignupForm").removeClass("hidden");
    }).always(function () {
        $("#newsletterSignupContainer .processing-signup").addClass("hidden");
    });
}

(function () {
    $(document).ready(function () {
        $("#newsletterSignupForm").submit(function (event) {
            event.preventDefault();

            if ($("#recaptchaToken").val().length > 0) {
                $("#recaptchaToken").val("");
                grecaptcha.reset();
            }

            $("#newsletterSignupRecaptchaModal").modal("show");
        });
    });

    $("#newsletterSignupRecaptchaModal").on("shown.bs.modal", function () {
      $(".modal-backdrop").addClass("fadeIn");
    });

    $("#newsletterSignupRecaptchaModal").on("hide.bs.modal", function () {
      $(".modal-backdrop").addClass("fadeOut");
    });
})();